// Central registry of Firestore collection names
export const COLLECTIONS = {
  users: "users",
  orders: "orders",
  products: "products",
  carts: "carts",
  userCart: "userCart",
  notifyMe: "notifyMe",
  query: "query",
  // add more as needed
} as const;

export type CollectionName = typeof COLLECTIONS[keyof typeof COLLECTIONS];


